import { VersionItemTypeEnums } from './share-type'

export const VersionItemTypeOptions = Object.values(VersionItemTypeEnums).map(value => ({
  label: value,
  value,
}))
